module.exports={
	"Form": "ContactViewManifest",
	"Scope": "Contact-View",
	"Descriptors":
	{
		"ContactDetails.Title":
		{
			"Name": "Title",
			"Hash": "Contact-View-Title",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Contact-View-Identity",
				"Group": "Contact-View-Identity"
			}
		},
		"ContactDetails.NameFirst":
		{
			"Name": "Name First",
			"Hash": "Contact-View-NameFirst",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-View-Details",
				"Group": "Contact-View-Details"
			}
		},
		"ContactDetails.NameLast":
		{
			"Name": "Name Last",
			"Hash": "Contact-View-NameLast",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-View-Details",
				"Group": "Contact-View-Details"
			}
		},
		"ContactDetails.NameFull":
		{
			"Name": "Name Full",
			"Hash": "Contact-View-NameFull",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Contact-View-Details",
				"Group": "Contact-View-Details"
			}
		},
		"ContactDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Contact-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Contact-View-Details",
				"Group": "Contact-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"ContactDetails.Email":
		{
			"Name": "Email",
			"Hash": "Contact-View-Email",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 6,
				"Section": "Contact-View-Contact",
				"Group": "Contact-View-Contact"
			}
		},
		"ContactDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "Contact-View-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Contact-View-Contact",
				"Group": "Contact-View-Contact"
			}
		},
		"ContactDetails.IDContact":
		{
			"Name": "IDContact",
			"Hash": "Contact-View-IDContact",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Contact-View-DataAudit",
				"Group": "Contact-View-DataAudit"
			}
		},
		"ContactDetails.GUIDContact":
		{
			"Name": "GUIDContact",
			"Hash": "Contact-View-GUIDContact",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Contact-View-DataAudit",
				"Group": "Contact-View-DataAudit"
			}
		},
		"ContactDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Contact-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Contact-View-DataAudit",
				"Group": "Contact-View-DataAudit"
			}
		},
		"ContactDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Contact-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Contact-View-DataAudit",
				"Group": "Contact-View-DataAudit"
			}
		},
		"ContactDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Contact-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Contact-View-DataAudit",
				"Group": "Contact-View-DataAudit"
			}
		},
		"ContactDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Contact-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Contact-View-DataAudit",
				"Group": "Contact-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Contact-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Contact-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Contact-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Contact-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "Contact-View-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "Contact-View-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Contact-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Contact-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
